import * as types from '../actions/actionTypes';
import serverApi from '../serverApi';
import { asyncActionCreator } from './asyncActionCreatorFactory';
import { squashIdIntoValue } from './utils';

export function fetchImageDestinationLocations() {
    return asyncActionCreator(types.IMAGE_DESTINATION_LOCATIONS_UPDATED, serverApi.fetchImageDestinationLocations({ take: 500 }),
     json => json.items.map(squashIdIntoValue));   
};

export function fetchImages() {
    return asyncActionCreator(types.IMAGES_UPDATED, serverApi.fetchImages({ take: 500 }),
     json => json.items.map(squashIdIntoValue));
};

export function fetchClones() {
    return asyncActionCreator(types.CLONES_UPDATED, serverApi.fetchClones({ take: 500 }),
        json => json.items.map(squashIdIntoValue));
};

export function fetchAgents() {
    return asyncActionCreator(types.AGENTS_UPDATED, serverApi.fetchAgents({ take: 500 }),
     json => json.items.map(squashIdIntoValue));
};

export function deleteClone(cloneId) {
    return asyncActionCreator(types.CLONE_DELETION_UPDATED, serverApi.deleteClone(cloneId),
        (json, responseStatus) => ( responseStatus === 202
            ? { cloneId: cloneId, operationId: json.id, operation: json.value }
            : { cloneId: cloneId }));
};

export function deleteImage(imageId) {
    return asyncActionCreator(types.IMAGE_DELETION_UPDATED, serverApi.deleteImage(imageId),
        (json, responseStatus) => ( responseStatus === 202
            ? { imageId: imageId, operationId: json.id, operation: json.value }
            : { imageId: imageId }));
};



// WEBPACK FOOTER //
// ./src/js/actions/manageModeActionCreators.js